import { useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { fetchUsers } from '../redux/actions/userActions';

/**
 * Custom hook to ensure customer data is loaded
 * @returns Customers array and loading state
 */
export const useCustomerData = () => {
  const dispatch = useAppDispatch();
  const { customers, loading, hasFetched } = useAppSelector(state => state.users);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Only try to fetch customer data if we haven't already tried
    // and there are no customers in the store AND we're not currently loading
    if (!hasFetched && customers.length === 0 && !loading) {
      console.log('useCustomerData: Attempting to fetch customer data');
      setIsLoading(true);
      
      dispatch(fetchUsers())
        .unwrap()
        .then((userData) => {
          console.log('useCustomerData: Successfully loaded customer data', userData?.customers?.length || 0, 'customers');
        })
        .catch(error => {
          console.error('useCustomerData: Failed to load customer data:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      // If we've already tried loading or have customers or not loading, set loading to false
      setIsLoading(false);
    }
  }, [dispatch, customers.length, loading, hasFetched]);

  return { customers, isLoading };
};
